import * as React from "react";
import { ListItemModel } from "../../models/ListItemModel";
import WorkListItem from "./work-list-item";

type DataProps = {
  color?: string;
  path: string;
  data: ListItemModel[];
};

const WorkList1 = ({ color, path, data }: DataProps): JSX.Element => {
  const contents = () => {
    const a = [];
    for (let i = 0; i < data.length; i++) {
      const item = data[i];

      a.push(
        <div
          key={i}
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <WorkListItem color={color} path={path} item={item} />
        </div>
      );
    }
    return a;
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
      {contents()}
    </div>
  );
};

export default WorkList1;
